module.exports = __webpack_public_path__ + "images/rank_logo_third-e2956fbd1b.png";